var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetaTabsSwitcher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9837_6025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 7.71419C5.99235 7.71419 1.00781 16.1839 1.00781 25.1401C1.00781 30.7467 3.7194 34.2878 8.2653 34.2878C11.5352 34.2878 13.8879 32.7485 18.0749 25.4352C18.0749 25.4352 19.8215 22.3568 21.0177 20.2354L23.506 16.0244C25.6195 12.7625 27.366 11.1356 29.4396 11.1356C33.7463 11.1356 37.1916 17.4759 37.1916 25.2677C37.1916 28.2345 36.2186 29.9572 34.2008 29.9572C32.2708 29.9572 31.3457 28.6812 27.6771 22.7795L24.3035 25.7223C28.1237 32.1185 30.2531 34.2878 34.1131 34.2878C38.5394 34.2878 41.0037 30.6909 41.0037 24.9647C41.0037 15.5778 35.9076 7.69824 29.7108 7.69824C26.4329 7.69824 23.8649 10.1706 21.5441 13.3049L18.9681 17.0851C16.424 20.993 14.8768 23.4414 14.8768 23.4414C11.4873 28.7609 10.3149 29.9492 8.4248 29.9492C6.47884 29.9492 5.3304 28.2425 5.3304 25.2039C5.3304 18.6961 8.57633 12.0448 12.4443 12.0448L12.5002 7.71419Z",
    fill: "url(#paint0_linear_9837_6025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7594 16.2482L18.9681 17.1095C16.424 21.0174 14.8768 23.4658 14.8768 23.4658C11.4873 28.7853 10.3149 29.9736 8.4248 29.9736C6.47884 29.9736 5.3304 28.2669 5.3304 25.2284C5.3304 18.7205 8.57633 12.0692 12.4443 12.0692L12.5002 7.72266C5.99235 7.71469 1.00781 16.1844 1.00781 25.1406C1.00781 30.7472 3.7194 34.2883 8.2653 34.2883C11.5352 34.2883 13.8879 32.749 18.0749 25.4357C18.0749 25.4357 19.8215 22.3573 21.0177 20.2358L21.7594 16.2482Z",
    fill: "url(#paint1_linear_9837_6025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3006 25.73C28.1208 32.1261 30.2502 34.2874 34.1102 34.2874L34.1979 29.9569C32.2679 29.9569 31.3428 28.6888 27.6742 22.7871C24.5957 17.7786 23.0246 15.2744 21.5412 13.3205C18.3511 9.26107 15.6873 7.71387 12.4972 7.71387L12.4414 12.0604C14.5389 12.0604 16.2855 13.2726 18.9652 17.1087C20.0897 18.6878 22.3945 22.4442 24.3006 25.73Z",
    fill: "url(#paint2_linear_9837_6025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5392 13.3205C18.3491 9.26107 15.6854 7.71387 12.4873 7.71387C9.33708 7.71387 6.54574 9.69971 4.49609 12.7622L7.57454 15.9124C8.85856 13.5916 10.5892 12.0684 12.4474 12.0684C14.5449 12.0684 16.2756 13.2646 18.9552 17.1007L21.5392 13.3205Z",
    fill: "url(#paint3_linear_9837_6025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4258 29.0801C29.0496 32.9002 31.0275 34.2879 34.1139 34.2879C38.5402 34.2879 41.0046 30.6911 41.0046 24.9648L37.1924 25.2679C37.1924 28.2347 36.2194 29.9574 34.2017 29.9574C32.6465 29.9574 31.7373 29.1279 29.5122 25.6986L26.4258 29.0801Z",
    fill: "url(#paint4_linear_9837_6025)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9837_6025",
    x1: 1.00781,
    y1: 20.993,
    x2: 41.0037,
    y2: 20.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061763,
    stopColor: "#006AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#007AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8106,
    stopColor: "#007DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9837_6025",
    x1: 4.55569,
    y1: 16.003,
    x2: 18.9856,
    y2: 30.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0134753,
    stopColor: "#0065E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2894,
    stopColor: "#0075F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5971,
    stopColor: "#007FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9837_6025",
    x1: 9.37492,
    y1: 5.54587,
    x2: 33.7673,
    y2: 31.9065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0216721,
    stopColor: "#017CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0904785,
    stopColor: "#0471EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1872,
    stopColor: "#066AE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4561,
    stopColor: "#0668E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7462,
    stopColor: "#056AE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#0472EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9742,
    stopColor: "#017CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9837_6025",
    x1: 4.49609,
    y1: 12.4073,
    x2: 21.5392,
    y2: 12.4073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4218,
    stopColor: "#0069E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4332,
    stopColor: "#0069E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0668E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9837_6025",
    x1: 26.4271,
    y1: 29.6264,
    x2: 41.0046,
    y2: 29.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066BE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3087,
    stopColor: "#0470E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0279F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9837_6025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8333,
    height: 40.8333,
    fill: "white",
    transform: "translate(0.582031 0.583984)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaTabsSwitcher);
export default __webpack_public_path__ + "static/media/meta_tabs_switcher.6fcf3af31f153ee1e7ffab12a89c11be.svg";
export { ForwardRef as ReactComponent };